module.exports = __webpack_public_path__ + "static/media/Sneasel_gaussian2.f6021952.png";